enum ActionTypes {
  TRACK_EVENT = 'TRACK_EVENT'
}

export default ActionTypes;
